"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPredictionTarget = exports.isBusinessImpact = exports.isDataSource = exports.isVersionedPredictor = exports.isEvaluationResult = exports.isCompleteEvaluationResult = exports.isPartialEvaluationResult = exports.isFailedEvaluation = exports.isFinishedEvaluation = exports.isInProgressEvaluation = exports.isEvaluationSettings = exports.isPredictorTarget = exports.isPredictorConfiguration = void 0;
const datelike_1 = require("../types/datelike");
const uuid_1 = require("../types/uuid");
const validation_1 = require("../validator/validation");
const isAitoColumn = (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    variable: (0, validation_1.isLiteral)('categorical', 'numerical'),
    element: (0, validation_1.isLiteral)('scalar', 'vector'),
    data: (0, validation_1.isLiteral)('boolean', 'int', 'long', 'decimal', 'string', 'text'),
    analyzer: (0, validation_1.isLiteral)('default').or(validation_1.isUndefined),
});
const isInputs = (0, validation_1.isArrayOf)(isAitoColumn);
exports.isPredictorConfiguration = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('default'),
    inputColumns: isInputs,
}));
exports.isPredictorTarget = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('single-column'),
    targetColumn: isAitoColumn,
}));
exports.isEvaluationSettings = (0, validation_1.isObjectOf)({
    maxSamples: validation_1.isNumber,
    sampleSplitRatio: validation_1.isNumber,
});
exports.isInProgressEvaluation = (0, validation_1.isObjectOf)({
    state: (0, validation_1.isLiteral)('pending'),
    progress: (0, validation_1.optional)((0, validation_1.isObjectOf)({
        completed: validation_1.isNumber,
        total: validation_1.isNumber,
    })),
});
exports.isFinishedEvaluation = (0, validation_1.isObjectOf)({
    state: (0, validation_1.isLiteral)('finished'),
    progress: (0, validation_1.optional)((0, validation_1.isObjectOf)({
        completed: validation_1.isNumber,
        total: validation_1.isNumber,
    })),
});
exports.isFailedEvaluation = (0, validation_1.isObjectOf)({
    state: (0, validation_1.isLiteral)('error'),
    error: (0, validation_1.optional)(validation_1.isString),
    nonAutomatedClasses: (0, validation_1.optional)((0, validation_1.isRecordOf)(validation_1.isNumber)),
    errorClasses: (0, validation_1.optional)((0, validation_1.isRecordOf)(validation_1.isNumber)),
});
exports.isPartialEvaluationResult = (0, validation_1.isObjectOf)({
    state: (0, validation_1.isLiteral)('partial'),
    modifiedAt: datelike_1.isDateLike,
    testSamples: validation_1.isNumber,
    trainSamples: validation_1.isNumber,
    accuracy: validation_1.isNumber,
    optimalConfidence: validation_1.isNumber,
    nonAutomatedClasses: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
    errorClasses: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
    importantColumns: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
});
exports.isCompleteEvaluationResult = (0, validation_1.isObjectOf)({
    state: (0, validation_1.isLiteral)('complete'),
    finishedAt: datelike_1.isDateLike,
    testSamples: validation_1.isNumber,
    trainSamples: validation_1.isNumber,
    accuracy: validation_1.isNumber,
    optimalConfidence: validation_1.isNumber,
    nonAutomatedClasses: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
    errorClasses: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
    importantColumns: (0, validation_1.isRecordOf)(validation_1.isNumber).or(validation_1.isUndefined),
});
exports.isEvaluationResult = (0, validation_1.isSomeOf)(exports.isInProgressEvaluation, exports.isFinishedEvaluation, exports.isFailedEvaluation, exports.isPartialEvaluationResult, exports.isCompleteEvaluationResult);
exports.isVersionedPredictor = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    target: exports.isPredictorTarget,
    configuration: exports.isPredictorConfiguration,
    version: validation_1.isNumber,
    description: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isNull, validation_1.isUndefined),
}));
exports.isDataSource = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('instance'),
    instanceId: uuid_1.isUUID,
    tableName: validation_1.isString,
}));
exports.isBusinessImpact = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('default'),
    unit: validation_1.isString,
    successCaseSavings: validation_1.isNumber,
    errorCaseCost: validation_1.isNumber,
    casesPerInterval: validation_1.isNumber,
    intervalUnit: validation_1.isString,
});
exports.isPredictionTarget = (0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    createdAt: datelike_1.isDateLike,
    name: validation_1.isString,
    impact: exports.isBusinessImpact,
    description: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isNull, validation_1.isUndefined),
    data: exports.isDataSource,
    evaluationSettings: exports.isEvaluationSettings,
    predictor: exports.isVersionedPredictor,
    deleted: validation_1.isBoolean,
    evaluationResults: (0, validation_1.optional)(exports.isEvaluationResult),
});
//# sourceMappingURL=evaluations.js.map